import React from "react"
import { smallText } from "../styles/helpers"
import { useRoutes } from "../hooks/useRoutes"
import { Trans, useTranslation } from "src/i18next"

export const PrivacyNotice: React.FC = () => {
  const { t } = useTranslation(["communicationDetails", "common"])

  const getRoutes = useRoutes()

  const privacyNotice = getRoutes({
    key: "privacyNotice",
    type: "full",
  })

  return (
    <span css={smallText}>
      <Trans
        t={t}
        i18nKey="communicationDetails:viewPrivacyNotice"
        components={{
          a: (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={privacyNotice}
              css={smallText}
            />
          ),
        }}
      />
    </span>
  )
}
